import _Link from "@arco-design/web-react/es/Link";
import _Input from "@arco-design/web-react/es/Input";
import _Message from "@arco-design/web-react/es/Message";
import _Result from "@arco-design/web-react/es/Result";
import _Modal from "@arco-design/web-react/es/Modal";
import _useRequest from "@byted/hooks/es/useRequest";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import { GetThemeDetailNoErrorTip } from '@api/theme';
import { IconCopy, IconLink, IconLoading } from '@arco-design/web-react/icon';
import style from './style.less';
import { copyText } from '@src/utils/dom';
var PublishStatusMap = [{
  status: "ready",
  text: '依赖安装中'
}, {
  status: "compiling",
  text: '样式文件编译中'
}, {
  status: "publishing",
  text: '发布中'
}, {
  status: "success",
  text: '🎉  发布成功'
}, {
  status: "error",
  text: '发布失败'
}];
var defaultTheme = {
  publishStatus: {
    status: "ready"
  }
};
export default (function (props) {
  var _a = __read(useState(defaultTheme), 2),
    data = _a[0],
    setData = _a[1];
  var _b = _useRequest(function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var result, res, e_1;
        var _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (!props.visible) return [3, 5];
              _b.label = 1;
            case 1:
              _b.trys.push([1, 3,, 4]);
              return [4, GetThemeDetailNoErrorTip({
                themeId: props.themeId
              })];
            case 2:
              res = _b.sent();
              setData(res);
              result = res;
              return [3, 4];
            case 3:
              e_1 = _b.sent();
              return [3, 4];
            case 4:
              if (['success', 'error'].indexOf((_a = result.publishStatus) === null || _a === void 0 ? void 0 : _a.status) > -1) {
                cancel();
              }
              _b.label = 5;
            case 5:
              return [2];
          }
        });
      });
    }, {
      refreshDeps: [props.themeId],
      auto: false,
      pollingInterval: 500
    }),
    run = _b.run,
    cancel = _b.cancel;
  var currentIndex = PublishStatusMap.findIndex(function (x) {
    var _a;
    return x.status === ((_a = data.publishStatus) === null || _a === void 0 ? void 0 : _a.status);
  });
  if (currentIndex === -1) {
    currentIndex = PublishStatusMap.length - 1;
  }
  return /*#__PURE__*/React.createElement(_Modal, {
    escToExit: false,
    autoFocus: false,
    focusLock: false,
    className: style['theme-publish-modal'],
    visible: props.visible,
    simple: true,
    title: currentIndex === 3 ? PublishStatusMap[currentIndex].text : '主题发布',
    footer: null,
    maskClosable: currentIndex > 2,
    closable: currentIndex > 2,
    afterOpen: run,
    onCancel: function onCancel() {
      cancel();
      setData(defaultTheme);
      props.onFinish && props.onFinish(data);
    }
  }, currentIndex < 3 ? /*#__PURE__*/React.createElement(_Result, {
    icon: /*#__PURE__*/React.createElement(IconLoading, null),
    status: "info",
    title: PublishStatusMap[currentIndex].text
  }) : currentIndex === 3 ? /*#__PURE__*/React.createElement("div", {
    className: style['theme-publish-success']
  }, /*#__PURE__*/React.createElement("p", null, "\u4E3B\u9898\u53D1\u5E03\u6210\u529F\uFF0C\u53EF\u70B9\u51FB\u4EE5\u4E0B\u94FE\u63A5\u8FDB\u884C\u67E5\u770B"), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      if (data === null || data === void 0 ? void 0 : data.packageName) {
        if (copyText(data.packageName)) {
          _Message.success('已复制到粘贴板');
        }
      }
    }
  }, /*#__PURE__*/React.createElement(_Input, {
    value: window.projectConfig.webNpmUrl + (data === null || data === void 0 ? void 0 : data.packageName),
    readOnly: true,
    addAfter: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconCopy, null), /*#__PURE__*/React.createElement("a", {
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      style: {
        marginLeft: 12,
        color: 'inherit'
      },
      target: "_blank",
      href: window.projectConfig.webNpmUrl + (data === null || data === void 0 ? void 0 : data.packageName),
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement(IconLink, null)))
  }))) : /*#__PURE__*/React.createElement(_Result, {
    status: "error",
    title: PublishStatusMap[currentIndex].text,
    subTitle: /*#__PURE__*/React.createElement(_Link, {
      onClick: function onClick() {
        var _a;
        _Modal.info({
          style: {
            width: 600
          },
          title: '详细信息',
          content: /*#__PURE__*/React.createElement("pre", {
            style: {
              width: '100%',
              overflow: 'auto',
              color: '#fff',
              background: '#232324'
            }
          }, (_a = data.publishStatus) === null || _a === void 0 ? void 0 : _a.errorLog)
        });
      }
    }, "\u70B9\u51FB\u67E5\u770B\u8BE6\u7EC6\u9519\u8BEF\u4FE1\u606F")
  }));
});